import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    connection: false,
    login: true,
    admin: null,
    listClients: [],
    linkTo: [],
    clientResponse: [],
    responseLog: {},
    monit: [],
  },
  mutations: {
    updateConnection(state) {
      state.connection = !state.connection;
    },
    updateLogin(state, data) {
      state.login = data;
    },
    updateAdmin(state, data) {
      state.admin = data;
    },
    updateListClients(state, data) {
      state.listClients = data;
    },
    updateLinkTo(state, data) {
      state.linkTo = data;
    },
    updateClientResponse(state, data) {
      // FIX this is getting updated but is note refreshed
      state.clientResponse = data;
    },
    updateResponseLog(state, data) {
      // FIX this is getting updated but is note refreshed
      state.responseLog = data;
    },
    updateMonit(state, data){
      state.monit.push(data);
    }
  }
});
